import { updateOfficeType } from "../../../../../actions/Utilities/OfficeType";
import { useMutation } from "react-query";

const useUpdateOfficeType = () => {
  return useMutation(updateOfficeType);
};
export default useUpdateOfficeType;
